import { Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useApi } from "../../../contexts/ApiContext";
import { useAuth } from "../../../contexts/AuthContext";
import { useError } from "../../../contexts/ErrorContext";
import lang from "../../../lang/en/pages.json";
import Main from "../../../layouts/Main";
import { useCaseManagement } from "../hooks/useCaseManagement";
import { CaseRevisionMeta } from "../types";
import RevisionsTable from "./RevisionsTable";
import { useCase } from "../../../contexts/CaseContext";
import {CaseMockResponse, CasesMockResponse, RevisionsMockResponse} from "../../../onboarding/mock";
import OnboardingModal from "../../../components/misc/OnboardingModal";
const Revisions: React.FC = () => {
  const [revisions, setRevisions] = React.useState<CaseRevisionMeta[]>([]);
  const navigate = useNavigate();
  const { client } = useApi();
  const { showError, showSuccess } = useError();
  const { createRevision } = useCaseManagement();
  const { user } = useAuth();
  const { caseMeta, revisionMeta } = useCase() || {};

  const { id: caseId, revisionId } = useParams();

  useEffect(() => {
    if (!caseMeta) {
      return;
    }

    if (caseMeta.status === "processing") {
      navigate(`/cases/${caseId}/status`);
    }

    if (!revisionMeta) {
      return;
    }
    if (!revisionId && !revisionMeta?.status) {
      navigate(`/cases/${caseId}/files`);
      return;
    }
  }, [revisionMeta, revisionId, caseMeta]);


  useEffect(() => {
    if (caseId) {
      const isExampleCase = caseMeta?.status === undefined ||
                           CasesMockResponse.some(c => c.id === caseId);

      if (!isExampleCase) {
        // Real case - fetch actual revisions
        const fetchRevisions = async () => {
          try {
            const response = await client.GET("/v1/cases/{case_id}/revisions/", {
              params: {
                path: { case_id: caseId },
              },
            });
            setRevisions(response.data as CaseRevisionMeta[]);
          } catch (error) {
            console.error("Error fetching revisions", error);
            showError("Error fetching revisions");
          }
        };
        fetchRevisions();
      } else {
        // Example case - always show mock revisions
        setRevisions(RevisionsMockResponse);
      }
    }
  }, [caseId, caseMeta]);


  // useEffect(() => {
  //   const fetchRevisions = async () => {
  //     if (!caseId) {
  //       return;
  //     }
  //     if (caseId === CaseMockResponse.id) {
  //       return;
  //     }
  //     try {
  //       const response = await client.GET("/v1/cases/{case_id}/revisions/", {
  //         params: {
  //           path: {
  //             case_id: caseId,
  //           },
  //         },
  //       });
  //
  //       setRevisions(response.data as CaseRevisionMeta[]);
  //     } catch (error) {
  //       console.error("Error fetching revisions", error);
  //       showError("Error fetching revisions");
  //     }
  //   };
  //   fetchRevisions();
  // }, []);


  const handleView = (revision: CaseRevisionMeta) => {
    navigate(`/cases/${caseId}/revisions/${revision.id}`);
  };

  return (
    <Main id="revisions_page">
      <Stack
        gap={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: 4,
        }}
      >
        <Stack 
          width={"30%"}
          alignItems={"center"}
          maxWidth={500}
          textAlign={"center"}
          spacing={2}
        >
          <Typography
            variant="h5"
            fontWeight={"bold"}
            sx={{ color: "#266A4A" }}
          >
            {lang.pages.revisions_page.title}
          </Typography>
        </Stack>
        <RevisionsTable
          revisions={revisions}
          onRowClick={(row: CaseRevisionMeta) => handleView(row)}
        />
      </Stack>
    </Main>
  );
};

export default Revisions;
